import { Component, ViewChild, inject } from '@angular/core';

import { LoginComponent } from '../login.component';
import { LoginMobileCredentialsStepComponent } from './credentials-step/login-mobile-credentials-step.component';
import { LoginMobileMfaStepComponent } from './mfa-step/login-mobile-mfa-step.component';

@Component({
  selector: 'app-login-mobile-view',
  templateUrl: './login-mobile-view.component.html',
  styleUrls: ['../shared-styles/login-device-view.component.scss'],
  standalone: false,
})
export class LoginMobileViewComponent {
  public readonly login = inject(LoginComponent);

  @ViewChild(LoginMobileCredentialsStepComponent) private credentialsStep?: LoginMobileCredentialsStepComponent;
  @ViewChild(LoginMobileMfaStepComponent) private mfaStep?: LoginMobileMfaStepComponent;

  public focusMainTitle(): void {}

  public focusCredentialInput(field: 'email' | 'password'): void {
    if (this.credentialsStep) {
      this.credentialsStep.focusCredentialInput(field);
      return;
    }

    setTimeout(() => this.credentialsStep?.focusCredentialInput(field));
  }

  public focusMfaInput(index: number): void {
    if (this.mfaStep) {
      this.mfaStep.focusMfaInput(index);
      return;
    }

    setTimeout(() => this.mfaStep?.focusMfaInput(index));
  }
}
